export interface IUserIdentifier {
	readonly tblUser_UID: number;
	equals(other: UserIdentifier): boolean;
}

export class UserIdentifier implements IUserIdentifier {
	private constructor(readonly tblUser_UID: number) {}

	equals(other: UserIdentifier) {
		return this.tblUser_UID === other.tblUser_UID;
	}

	public static byPrimaryKey(tblUser_UID: number) {
		return new UserIdentifier(tblUser_UID);
	}
}
